import React, { useState } from 'react';
import axios from 'axios';
import { Send, CheckCircle, Loader } from 'lucide-react';

/**
 * Usage: <TriggerAssessmentButton candidateId={candidate.id} alreadySent={!!candidate.assessmentSubmission} attemptCount={candidate.assessmentAttemptCount} />
 */
export default function TriggerAssessmentButton({ candidateId, alreadySent, attemptCount = 0 }) {
  const [sent, setSent] = useState(!!alreadySent);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(attemptCount);

  const handleTrigger = async () => {
    if (loading) return;

    const confirmMsg = sent
      ? 'This candidate already has an assessment on record. Send a new one?'
      : 'Send assessment link to this candidate now?';

    if (!window.confirm(confirmMsg)) return;

    try {
      setLoading(true);
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/assessment/trigger/${candidateId}`);
      setSent(true);
      setCount((c) => c + 1);
    } catch (err) {
      console.error('Trigger Assessment Error:', err);
      alert(err.response?.data?.message || 'Failed to trigger assessment');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>
      {sent && (
        <span style={{
          display: 'flex', alignItems: 'center', gap: '4px',
          color: '#16a34a', fontSize: '0.8rem', fontWeight: 600
        }}>
          <CheckCircle size={13} /> Sent{count > 1 ? ` (${count} attempts)` : ''}
        </span>
      )}
      <button
        onClick={handleTrigger}
        disabled={loading}
        style={{
          display: 'flex', alignItems: 'center', gap: '6px',
          padding: '6px 12px', borderRadius: '6px', border: '1px solid #2563eb',
          background: loading ? '#eff6ff' : sent ? '#fff' : '#2563eb',
          color: loading ? '#2563eb' : sent ? '#2563eb' : '#fff',
          fontSize: '0.85rem', fontWeight: 600,
          cursor: loading ? 'not-allowed' : 'pointer'
        }}
        title={sent ? 'Send a new assessment link' : 'Send assessment link to candidate'}
      >
        {loading ? <Loader size={14} /> : <Send size={14} />}
        {loading ? 'Sending...' : sent ? 'Resend Assessment' : 'Trigger Assessment'}
      </button>
    </div>
  );
}